
import { cloneLoop } from '@/shared/jsmini-clone/index';

const updateEnvConfig = (vm, index, model) => {
  if (model?.id) {
    const { uiApp } = vm.mForm.editor.editorCore;
    const comp = uiApp.getComponent(model.id);
    comp.magicEnvConfig = vm.model[vm.config.name][+index];
  }
};

export default [{
  text: '组件名称',
  name: 'name',
},
{
  type: 'component',
  id: 'devConfig',
}, {
  type: 'switch',
  name: 'hiddenAtStart',
  text: '首屏隐藏',
}, {
  type: 'component',
  id: 'rect',
}, {
  type: 'dynamicTab',
  active: '0',
  tabType: 'border-card',
  editable: true,
  name: 'envConfigs',
  onChange(vm, { model }) {
    updateEnvConfig(vm, vm.activeTabName, model);
  },
  onTabClick(vm, tab, { model }) {
    updateEnvConfig(vm, +tab.name, model);
  },
  onTabRemove: (vm, tabName, { model }) => {
    if (model[vm.config.name].length > 1) {
      model[vm.config.name].splice(+tabName, 1);
      if (tabName < vm.activeTabName || vm.activeTabName >= model[vm.config.name].length) {
        // eslint-disable-next-line no-param-reassign
        vm.activeTabName = (+vm.activeTabName - 1).toString();
        updateEnvConfig(vm, vm.activeTabName, model);
      }
    }
  },
  onTabAdd: (vm, { model }) => {
    const { length } = model[vm.config.name];
    const newObj = cloneLoop(model[vm.config.name][0]);
    newObj.title = `渠道${length + 1}配置`;
    newObj.channels = [];
    newObj.src = 'https://puui.qpic.cn/vupload/0/1573555382625_bhp0wud8l6w.png/0';
    newObj.renderPag = false;
    newObj.pagSrc = '';
    model[vm.config.name].push(newObj);
    // eslint-disable-next-line no-param-reassign
    vm.activeTabName = length.toString();

    updateEnvConfig(vm, vm.activeTabName, model);
  },
  items: [{
    name: 'title',
    type: 'hidden',
  }, {
    text: '标题',
    name: '_title',
    onChange(vm, value, { model }) {
      const formModel = model;
      // 自定义标题，此标题非空，使用此标题
      if (value) {
        formModel.title = value;
      } else {
        formModel.title = formModel.channels?.join('/') ?? '';
      }
    },
  }, {
    type: 'checkboxGroup',
    name: 'channels',
    text: '展示渠道',
    onChange(vm, value, { model }) {
      const formModel = model;
      // eslint-disable-next-line no-underscore-dangle
      if (value && value.length && !formModel._title) {
        // 自定义标题_title为空时，自动根据渠道生成标
        formModel.title = value.join('/');
      }
    },
    options: [
      { value: 'iphoneApp', text: 'iPhone 腾讯视频' },
      { value: 'iphoneMqq', text: 'iPhone QQ' },
      { value: 'ipadApp', text: 'iPad 腾讯视频' },
      { value: 'ipadMqq', text: 'iPad QQ' },
      { value: 'androidApp', text: 'Android 腾讯视频' },
      { value: 'wechatH5', text: '微信' },
      { value: 'h5', text: '其他(H5环境)' },
    ],
  }, {
    type: 'switch',
    name: 'renderPag',
    text: '渲染PAG',
  }, {
    text: '图片',
    type: 'upload',
    drag: true,
    name: 'src',
    async onChange(vm, value, { formValue, model }) {
      const resizable = [-1, 0].includes((formValue.envConfigs || []).indexOf(model));
      if (!resizable || !value) return;
      const imgEl = await new Promise((resolve) => {
        const img = new Image();
        img.onload = function () {
          resolve(this);
        };
        img.src = value;
      });

      const clientWidth = +formValue.style.width
        || document.getElementById(formValue.id).clientWidth
        || Math.min(imgEl.naturalWidth, 375);
      vm.$set(formValue.style, 'height', clientWidth * imgEl.naturalHeight / imgEl.naturalWidth);
      vm.$set(formValue.style, 'width', clientWidth);
    },
    display: (vm, { model }) => !model.renderPag,
  }, {
    text: 'PAG',
    type: 'act-upload',
    drag: true,
    name: 'pagSrc',
    display: (vm, { model }) => !!model.renderPag,
  }, {
    text: '链接',
    name: 'href',
    trim: true,
  }],
}];
